import React from 'react'
import Components from '../components/components'

export default function renderElement(component, props) {
  if (!Components[component]) return null
  return React.createElement(Components[component], props)
}
